module.exports = __webpack_public_path__ + "static/linkedlist-2.2-d2932ff1efaec8e7d9c92da77bd890b0.png";